/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import dtm from 'scripts/services/dtm';
import scheduleDataView from './tv-schedule.stache';
import scheduleDateSelectorView from './tv-schedule-date-selector.stache';
import 'components/right-rail/tv-schedule/tv-schedule';
import _ from 'lodash';
import dayjs from 'dayjs';
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";

dayjs.extend(isSameOrAfter)
const dateFormat = 'dddd, MMM D, YYYY';

export const RightRailTvSchedule = BaseControl.extend({
    init: function () {
        this._super();

        this.$dateSelector = this.$element.find('.js-tv-schedule-date-selector');
        this.$scheduleContent = this.$element.find('.js-tv-schedule-content');

        if (_.isEmpty(this.options.events) || !_.isArray(this.options.events)) {
            console.error('An "events" property is empty or not an array');
            return;
        }

        this.eventDates = this.options.events.sort((left, right) =>
            dayjs.utc(left.broadcastStart).diff(dayjs.utc(right.broadcastStart))
        ).map(date => dayjs(date.broadcastStart).format(dateFormat));

        const closestDate = this.eventDates
            .filter(date => dayjs(date).isSameOrAfter(dayjs(), 'day'))[0] || this.eventDates[0];
        const availableDates = _.uniqBy(this.eventDates);
        const defaultFormattedDate = dayjs(this.options.date).format(dateFormat);
        const defaultDate = availableDates.indexOf(defaultFormattedDate) > -1 ? defaultFormattedDate : closestDate;

        this.$dateSelector
            .html(scheduleDateSelectorView({
                availableDates: availableDates,
                date: defaultDate
            }));

        this.$currentDateContainer = this.$element.find('.js-current-date');
        this.$selectedDate = this.$element.find('.js-item.is-selected');

        if (this.options.events && this.options.events.length) {
            this.displayBroadcast(defaultDate);
        }
    },

    displayBroadcast: function (date) {
        const availableEvents = this.options.events
            .filter(event => dayjs(event.broadcastStart).isSame(date, 'day'));

        this.$scheduleContent
            .html(scheduleDataView({
                events: availableEvents,
                date: date,
                championshipPage: this.options.championshipPage
            }));
    },

    '.js-tv-schedule-date-selector click': function (el) {
        $(el.context).toggleClass('is-expanded')
    },

    '.js-item click': function (el) {
        const target = $(el.context);
        const targetDate = target.data('date');
        this.$selectedDate.removeClass('is-selected');
        this.$selectedDate = target.addClass('is-selected');
        this.$currentDateContainer.html(targetDate);
        this.displayBroadcast(targetDate);
        dtm.trackRightRailDropdownSelection('RightRailTvSchedule');
    },

    '.s-btn--more click': function (el) {
        dtm.trackRightRailLinkToFullClick('RightRailTvSchedule');
    }
});
